import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Appointment from './components/Appointment';
import Navbar from './components/Navbar';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import Read from './components/read';
import EmployeeWorkLog from './components/EmployeeWorkLog';
import UpdateInventory from './components/Update_inventory';
import BasicTable from './components/Inventory_list';
import FetchEmployee from './components/FetchEmployee';
import Login from './components/Login';
import TransferTable from './components/Tranfer_table';
import Footer from './components/Footer';
import { Box } from '@mui/material';
import AddMemberForm from './components/MembershipManagement/AddMemberForm';
import AdminApprovalPage from './components/MembershipManagement/AdminApprovalPage';
import MembershipMgmt from './components/MembershipManagement/MembershipMgmt';
import EditForm from './components/MembershipManagement/EditForm';
import Cookies from 'js-cookie';
import AdminChecklist from './components/AdminChecklist';
import UserChecklist from './components/UserChecklist';
import MembershipDataUpload from './components/MembershipManagement/MembershipDataUpload';
import MembershipReports from './components/MembershipManagement/MembershipReports';
import MembershipCard from './components/MembershipManagement/MembershipCard';
import UserManagement from './components/UserManagement';
import TenantManagement from './components/TenantManagement';
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ThirdParty from './components/ThirdParty';

const App = () => {
  const [authState, setAuthState] = useState({
    isLoggedIn: false,
    isAppAdmin: false,
    isAppUser: false,
    isSuperAdmin: false,
    userEmail: '',
    tenantId: '',
    tenantName: ''
  });

  const updateAuthState = (newState) => {
    setAuthState(prevState => ({
      ...prevState,
      ...newState
    }));
  };

  // Function to check authentication state from cookies
  const checkAuthState = () => {
    const token = Cookies.get('jwtToken');
    const userRole = Cookies.get('userRole');
    const isAppAdminCookie = Cookies.get('isAppAdmin');
    const isAppUserCookie = Cookies.get('isAppUser');
    const isSuperAdminCookie = Cookies.get('isSuperAdmin');
    const userEmailCookie = Cookies.get('userEmail');
    const tenantIdCookie = Cookies.get('tenantId');
    const tenantNameCookie = Cookies.get('tenantName');
    
    if (token) {
      updateAuthState({
        isLoggedIn: true,
        isAppAdmin: isAppAdminCookie === 'true',
        isAppUser: isAppUserCookie === 'true',
        isSuperAdmin: isSuperAdminCookie === 'true',
        userEmail: userEmailCookie || '',
        tenantId: tenantIdCookie || '',
        tenantName: tenantNameCookie || ''
      });
    } else {
      updateAuthState({
        isLoggedIn: false,
        isAppAdmin: false,
        isAppUser: false,
        isSuperAdmin: false,
        userEmail: '',
        tenantId: '',
        tenantName: ''
      });
    }
  };

  // Check auth state on mount and when cookies change
useEffect(() => {
  const token = Cookies.get('jwtToken');

  if (token) {
    setAuthState({
      isLoggedIn: true,
      isAppAdmin: Cookies.get('isAppAdmin') === 'true',
      isAppUser: Cookies.get('isAppUser') === 'true',
      isSuperAdmin: Cookies.get('isSuperAdmin') === 'true',
      userEmail: Cookies.get('userEmail') || '',
      tenantId: Cookies.get('tenantId') || '',
      tenantName: Cookies.get('tenantName') || ''
    });
  }
}, []);


  return (
    <>
      <Router>
        <Navbar 
          isLoggedIn={authState.isLoggedIn} 
          isAppAdmin={authState.isAppAdmin || authState.isSuperAdmin} 
          isAppUser={authState.isAppUser}
          isSuperAdmin={authState.isSuperAdmin} 
        />
        <Box sx={{ paddingBottom: '60px' }}>
          <Routes>
            <Route exact path="/login" element={<Login updateAuthState={updateAuthState} />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/" element={<Home />} />
            <Route exact path="/addMemberForm" element={<AddMemberForm />} />
            <Route exact path="/user" element={<UserChecklist email={authState.userEmail} />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/third-party" element={<ThirdParty/>}/>

            {authState.isLoggedIn && (
              <>
                <Route 
                  exact path="/appointment" 
                  element={<Appointment isAppAdmin={authState.isAppAdmin || authState.isSuperAdmin} email={authState.userEmail} />} 
                />
                <Route exact path="/membership-card" element={<MembershipCard />} />
              </>
            )}

            {authState.isLoggedIn && (authState.isSuperAdmin || authState.isAppAdmin) && (
              <>
                <Route exact path="/user-management" element={<UserManagement />} />
                {authState.isSuperAdmin && (
                <Route exact path="/tenant-management" element={<TenantManagement />} />
                )}
              </>
            )}

            {authState.isLoggedIn && (authState.isAppAdmin || authState.isSuperAdmin) && (
              <>
                <Route exact path="/admin" element={<AdminChecklist email={authState.userEmail} />} />
                <Route path="/update_inventory" element={<UpdateInventory />} />
                <Route path="/inventory_list" element={<BasicTable />} />
                <Route exact path="/details" element={<Read />} />
                <Route exact path="/transfer_list" element={<TransferTable />} />
                <Route path="/editMembership/:id" element={<EditForm isAppAdmin={authState.isAppAdmin || authState.isSuperAdmin}/>} />
                <Route exact path="/membermgmt" element={<MembershipMgmt isAppAdmin={authState.isAppAdmin || authState.isSuperAdmin}/>} />
                <Route exact path="/adminApproval" element={<AdminApprovalPage />} />
                <Route exact path="/membershipreports" element={<MembershipReports />} />
                <Route exact path="/membership-data-upload" element={<MembershipDataUpload isAppAdmin={true} />} />
              </>
            )}

            {authState.isLoggedIn && ((authState.isAppAdmin || authState.isSuperAdmin) || authState.isAppUser) && (
              <>
                <Route exact path="/services" element={<EmployeeWorkLog isAppAdmin={authState.isAppAdmin || authState.isSuperAdmin} isAppUser={authState.isAppUser} />} />
                <Route exact path="/service_list" element={<FetchEmployee />} />
              </>
            )}
          </Routes>
        </Box>
      </Router>
      <Footer />
    </>
  );
};

export default App;
